
// auth-error.interceptor.ts
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          // Limpa tokens se necessário
          //alert("401");
          //localStorage.clear();
          // Redireciona para a página inicial (ajuste se for /login)
            //router.navigate(['/iniciar']);
        } else if (err.status === 403) {
          //router.navigate(['/']);
        }
      }
           return throwError(() => err);
    })
  );
}
